import React from 'react';

export const Check = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--check';
  color = color || '#0076CC';

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M1 7L5 11L15 1"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Check;
